export enum IknowActionType {
  Study = 'study',
  Add = 'Add',
}

// Storage keys
export const IKNOW_TOKEN_KEY = 'iknow_token';
export const IKNOW_PENDING_ACTION_KEY = 'pending_action';
export const IKNOW_PENDING_ACTION_TARGET_ID_KEY = 'pending_action_target_id';
